import ApiService from "@/common/api/api.service";

const FNDCTService = {
  listar(porPagina = 0, pagina = 0) {
    return ApiService.get(`BoletoFNDCT?TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  buscarPorId(id) {
    return ApiService.get(`BoletoFNDCT/${id}`);
  },
  salvar(form) {
    let result = [];
    if (!form.id) result = ApiService.post(`BoletoFNDCT`, { ...form });
    else result = ApiService.put(`BoletoFNDCT`, { ...form });
    return result;
  },
  excluir(id) {
    return ApiService.delete(`BoletoFNDCT?id=${id}`);
  },
};

export default FNDCTService;
